module.exports = __webpack_public_path__ + "static/img/cont32_07.5fc9daf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_07.jpg
// module id = KPcJ
// module chunks = 0